import { editClientRenewSecret, getClientAppList } from "@payping/redux/actions";
import { Modal, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { Dispatch, FC, SetStateAction } from "react";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { ConfirmModalProps } from "@/components/DashIpg/ConfirmModal";

interface Props {
  clientId: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmModalOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmModalData: Dispatch<SetStateAction<ConfirmModalProps | undefined>>;
}

const TokenRenew: FC<Props> = (props) => {
  const { clientId, setOpen, open, setConfirmModalData, setConfirmModalOpen } = props;
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();

  function hideModal() {
    setOpen(false);
  }

  const [, handleRenew] = useMessagedAsyncFn(async () => {
    const { secret } = await dispatch(editClientRenewSecret(clientId as string));

    setConfirmModalData({ client: { clientId, clientSecret: secret } });
    setConfirmModalOpen(true);

    await dispatch(getClientAppList());
  }, [clientId]);

  return (
    <Modal
      title={t("oauth.renew.renewOauth")}
      open={open}
      okText={t("oauth.renew.renewOauth")}
      onOk={() => handleRenew()}
      cancelText={t("return")}
      onCancel={() => hideModal()}
    >
      <Typography.Paragraph>{t("oauth.renew.attention")}</Typography.Paragraph>
    </Modal>
  );
};

export default TokenRenew;
